import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Cpu, HandCoins, Receipt, UserCheck } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "../motion/Reveal";
import { FlowRail } from "./FlowRail";
import { useSite } from "../../lib/site";

export const Principle = () => {
  const { content } = useSite();
  const p = content.principio;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="grain relative overflow-hidden bg-ink py-24 text-white sm:py-32 lg:py-40" data-testid="principio-section">
      <div className="pointer-events-none absolute right-0 top-1/3 h-[480px] w-[480px] rounded-full bg-azure/20 blur-[150px]" />
      <div className="container-x relative">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Eyebrow>{p.eyebrow}</Eyebrow>
            <MaskLines lines={p.title_lines} className="h-section mt-6" testId="principio-title" />
            <Reveal className="mt-10">
              <p className="font-display text-2xl font-medium leading-snug tracking-tight text-white sm:text-3xl">“{p.quote}”</p>
            </Reveal>
            <Reveal className="mt-8 space-y-4 text-lg leading-relaxed text-[#C9D0E4]" delay={0.1}>
              {p.paragraphs.map((t, i) => (
                <p key={i}>{t}</p>
              ))}
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal className="spotlight relative mx-auto aspect-square w-full max-w-[460px] overflow-hidden rounded-full border border-white/10">
              <motion.img style={{ y, scale: 1.18 }} src={content.media.principio_image} alt="Dueño de una cafetería mostrando una solución digital a su cliente" className="h-full w-full object-cover" />
            </Reveal>
          </div>
        </div>
        <div className="mt-20 border-t border-white/10 pt-12 lg:mt-28">
          <FlowRail items={p.chain} notes={p.chain_notes} icons={[UserCheck, Cpu, Receipt, HandCoins]} tone="dark" testId="principio-chain" />
        </div>
      </div>
    </section>
  );
};
